import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import { useA11y } from '@context/Utils/A11y';
import { LegitimationMethod } from './LegitimationMethod';
import { LegitimationSuccess } from './LegitimationSuccess';
import { Meta } from '@core/Meta';
import { keyValueValidation } from '@utils/globalConstant';
import { useTitle } from '@context/Utils/Title';
export function ActivationStep6() {
  // Context
  const { step6SubStep } = useActivation();
  const { tA11yTranslate, getGlobalMetaTitles } = useA11y();
  const { announceTitle } = useTitle();
  // META: page titles
  const { globalPageTitle, globalSuccessPageTitle } = getGlobalMetaTitles();
  const activationChooseLegitimationPageTitle = tA11yTranslate(
    'ek_global_meta_title_choose_legitimation'
  ).content;
  const isTranslationReady = keyValueValidation(
    activationChooseLegitimationPageTitle,
    'ek_global_meta_title_choose_legitimations'
  );

  // Determine the page title based on the current substep
  const getPageTitle = () => {
    if (step6SubStep === 1) {
      return `${globalPageTitle} - ${globalSuccessPageTitle}`;
    } else {
      return `${globalPageTitle} - ${activationChooseLegitimationPageTitle}`;
    }
  };

  useEffect(() => {
    const pageTitle = `${getPageTitle()}`;
    announceTitle(pageTitle);
  }, [step6SubStep, announceTitle]); // Re-run when substep changes

  const renderStep6SubSteps = (subStep) => {
    switch (subStep) {
      case 0:
        return <LegitimationMethod />;
      case 1:
        return <LegitimationSuccess />;
      default:
        return <LegitimationMethod />;
    }
  };

  return (
    <>
      <Meta title={getPageTitle()} key={`meta-key-${step6SubStep}`} />
      {renderStep6SubSteps(step6SubStep)}
    </>
  );
}

export default ActivationStep6;
